import { styled } from '@mui/material/styles';
import { Box, SvgIcon } from '@mui/material';
import { getThemeColor } from '../../../utils/styleUtils';

export const StyledSvgIcon = styled(SvgIcon)(({ fontSize, color }) => ({
  ...(fontSize !== 'small' &&
  fontSize !== 'medium' &&
  fontSize !== 'large' &&
  fontSize
    ? { fontSize: fontSize }
    : {}),
  ...(color && color.startsWith('#') ? { color: color } : {}),
}));

export const StyledBackground = styled(Box)(
  ({
    backgroundcolor,
    backgroundshape,
    backgroundwidth,
    backgroundheight,
    bordersize,
    bordercolor,
    theme,
  }) => ({
    ...(backgroundcolor
      ? { backgroundColor: getThemeColor(backgroundcolor, theme) }
      : {}),
    ...(backgroundshape === 'square' ? { borderRadius: '0' } : {}),
    ...(backgroundshape === 'square-rounded' ? { borderRadius: '10px' } : {}),
    ...(backgroundshape === 'circle' ? { borderRadius: '50%' } : {}),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: backgroundwidth,
    height: backgroundheight,
    ...(bordersize ? { border: `${bordersize} solid` } : {}),
    ...(bordercolor ? { borderColor: getThemeColor(bordercolor, theme) } : {}),
  }),
);
